import React, { Fragment, useEffect, useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const SkltnTicketDetails = () => {

    const [state, setState] = useState([1, 2, 3, 4, 5, 6, 7, , 8])

    return (
        <Fragment>
            {state.map((info, index) =>
                <div className="messageItem skltn" key={index}>
                    <div className="username">
                        <div className="user">
                            <Skeleton animation="wave" width={47} height={47} />
                            <Skeleton animation="wave" width={100} height={24} />
                        </div>
                        <span className="date">
                            <Skeleton animation="wave" width={100} height={22} />
                        </span>
                    </div>
                    <p className="desc">
                        <Skeleton animation="wave" width={90 + '%'} height={24} />
                        <Skeleton animation="wave" width={100 + '%'} height={24} />
                    </p>
                    <Skeleton animation="wave" width={270} height={120} />
                </div>
            )}
        </Fragment>
    )
}

export default SkltnTicketDetails;